import { useAuth } from '../../../contexts/AuthContext';
import { PractitionerAssignmentsQuery } from '../../../generated/graphql';
import useLocalStorageValue from '../../hooks/useLocalStorageValue';
import { INSIGHTS_PRACTITIONER_SECTIONS_EXPANDED } from '../../lib/storage';

import PractitionerCard from './PractitionerCard';
import type { ClientsDateRange } from './insightsFilters';

type PractitionerAssignment =
  PractitionerAssignmentsQuery['practitionerAssignments'][number];

type ExpandedMap = Record<string, boolean>;

type PractitionerListProps = {
  practitioners?: PractitionerAssignment[] | null;
  loading?: boolean;
  dateRange: ClientsDateRange | null;
};

const PractitionerList = ({
  practitioners = [],
  loading,
  dateRange,
}: PractitionerListProps) => {
  const { authedProviderUser } = useAuth();
  const [expandedMap, setExpandedMap] = useLocalStorageValue<ExpandedMap>(
    INSIGHTS_PRACTITIONER_SECTIONS_EXPANDED,
    authedProviderUser.id,
    authedProviderUser.provider.id,
  );

  if (loading) return null;

  const isExpanded = (practitionerId: string) =>
    expandedMap?.[practitionerId] ?? true;

  const toggleExpanded = (practitionerId: string) => {
    setExpandedMap({
      ...(expandedMap ?? {}),
      [practitionerId]: !isExpanded(practitionerId),
    });
  };

  return (
    <>
      {(practitioners ?? []).map((practitionerData, index) => (
        <PractitionerCard
          key={practitionerData.practitioner.id}
          delay={index * 0.2}
          practitioner={practitionerData.practitioner}
          clients={practitionerData.assignedClients}
          dateRange={dateRange}
          isExpanded={isExpanded(practitionerData.practitioner.id)}
          onToggleExpanded={() =>
            toggleExpanded(practitionerData.practitioner.id)
          }
        />
      ))}
    </>
  );
};

export default PractitionerList;
